import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

/**
 * Поиск деталей при создании новой заявки на компенсацию.
 */
export default class extends Controller {
  static get targets() {
    return ['input', 'parts'];
  }

  initialize() {
    this.timeout = null;
    this.renderedArticle = null;
  }

  connect() {
    this.partId = parseInt(this.data.get('part_id'));
    this.userId = parseInt(this.data.get('user_id'));

    this.inputTarget.addEventListener('change', () =>
      this.searchParts()
    );
    this.inputTarget.addEventListener('keydown', () =>
      this.searchParts()
    );
    this.inputTarget.addEventListener('paste', () =>
      this.searchParts()
    );

    if (this.inputTarget.value.length > 0) {
      this.searchParts();
    }
  }

  disconnect() {
    this.inputTarget.removeEventListener('change', () =>
      this.searchParts()
    );
    this.inputTarget.removeEventListener('keydown', () =>
      this.searchParts()
    );
    this.inputTarget.removeEventListener('paste', () =>
      this.searchParts()
    );
  }

  checkSelectedPart() { }

  renderLoader() {
    this.partsTarget.innerHTML = `<br><div class="loader is-pulled-left"></div>&nbsp;Ищем деталь в нашей базе...`;
  }

  renderNotFound(article) {
    this.partsTarget.innerHTML = `<br><p class="content is-paddingless">Деталь «${article}» не найдена в нашей базе.</p>`;
  }

  renderPart(part) {
    if (part.rule_id) {
      const checked = this.partId === part.id;

      return `
    <div class="control">
      <label class="radio">
        <input type="radio" data-rule="${part.rule_id}" data-rule-text="${part.rule_text.replace(/"/g, '&quot;')}" data-sum="${part.sum}" name="compensation[part_id]" value="${part.id}" ${checked ? 'checked' : ''} data-action="click->user--search-parts-without-offer#checkValue">
        ${part.brand} ${part.article} ${part.description}
      </label>
    </div>
    `;
    } else {
      return `
    <div class="control">
      <label class="radio has-text-line-through" title="Деталь не соответствует ни одному условию для компенсации">
        ${part.brand} ${part.article} ${part.description}
      </label>
    </div>
    `;
    }
  }

  checkValue() {
    let part = document.querySelectorAll('input[name="compensation[part_id]"]:checked')[0];
    document.querySelectorAll('input[name="compensation[compensation_rule_id]"]')[0].value = part.dataset.rule;
    document.querySelectorAll('input[name="compensation[sum]"]')[0].value = part.dataset.sum;
    document.getElementById("compensation-rule-sum").value = part.dataset.sum + ' ₽';

    document.getElementById("compensation-rule-content").innerHTML = part.dataset.ruleText;
    document.getElementById("compensation-rule").style.display = "block";
    document.getElementById("compensation-rule-modal").classList.add("is-active");
  }

  renderParts(parts) {
    let result = [];
    const simpleParts = [];
    for (const part of parts) {
      simpleParts.push(this.renderPart(part));
    }

    if (simpleParts.length > 0) {
      if (result.length > 0) result.push('<br>');

      result.push(`
    <br><p class="has-text-weight-bold">Выберите деталь из списка:</p>
    `);
      result = [...result, ...simpleParts];
    }

    this.partsTarget.innerHTML = result.join('');

    this.checkSelectedPart();
  }

  searchParts() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const article = this.inputTarget.value;
      const userId = this.userId;
      if (article.length > 2 && article !== this.renderedArticle) {
        this.renderLoader();

        const that = this;
        Rails.ajax({
          type: 'GET',
          url: `/compensations/search_parts_without_offer.json?query=${article}&user_id=${userId}`,
          success: (data) => {
            if (data.length > 0) {
              that.renderParts(data);
            } else {
              that.renderNotFound(article);
            }

            that.renderedArticle = article;
          },
          error: () => {
            alert('Ошибка при попытке найти детали по вашему запросу');
          },
        });
      }
    }, 400);
  }
}
